export type PoPendingEmail = {
  id: string;
  subject: string;
  received: string;
};

function proxyKey(): string {
  const key = import.meta.env.VITE_DEM_EMAIL_PROXY_KEY?.trim();
  if (!key) {
    throw new Error('VITE_DEM_EMAIL_PROXY_KEY is not configured for email monitor.');
  }
  return key;
}

async function callMonitor<T>(body: Record<string, unknown>): Promise<T> {
  const res = await fetch('/po-email-monitor-api', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-DEM-Email-Key': proxyKey(),
    },
    body: JSON.stringify(body),
  });

  const text = await res.text();
  if (!res.ok) {
    try {
      const json = JSON.parse(text) as { error?: string };
      throw new Error(json.error || `Email monitor failed (${res.status})`);
    } catch (e) {
      if (e instanceof Error && e.message !== text) throw e;
      throw new Error(text || `Email monitor failed (${res.status})`);
    }
  }

  return JSON.parse(text) as T;
}

export async function fetchPendingPoEmails(): Promise<PoPendingEmail[]> {
  const json = await callMonitor<{ emails?: PoPendingEmail[] }>({ action: 'list' });
  return Array.isArray(json.emails) ? json.emails : [];
}

export async function downloadPoEmail(messageId: string): Promise<{ subject: string; emlBase64: string }> {
  return callMonitor<{ subject: string; emlBase64: string }>({
    action: 'download',
    messageId,
  });
}

export async function dismissPoEmail(messageId: string): Promise<void> {
  await callMonitor<{ ok?: boolean }>({ action: 'dismiss', messageId });
}
